import { SxProps } from '@mui/material'
import { dateRangePickerYearsClasses as classes } from './DateRangePickerYears.data'
import { calendarDimensions } from '../DateRangePicker.data'

interface DateRangePickerYearsStyles {
  wrapper: SxProps
  yearsWrapper: SxProps
  button: SxProps
  text: SxProps
}

export const dateRangePickerYearsStyles: DateRangePickerYearsStyles = {
  wrapper: {
    height: calendarDimensions.height,
    overflowY: 'auto',
  },
  yearsWrapper: {
    gap: 1.25,
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  button: {
    height: 35,
    width: '100%',
    maxWidth: 100,
    borderRadius: 5,
    mx: 'auto',

    [`&:hover, &.${classes.selected}`]: {
      color: 'text.primaryContrast',
      backgroundColor: 'brand.primary600',
    },
  },
  text: {
    typography: 'textSm',
  },
}
